var enUS = {
	"image-not-available": "This image is not available."
};

export { enUS as default };
